(function() {
  "use strict";


  var app = angular.module('default.service', ['i18n.provider']);

  app.factory('$breadcrumbs', ['$rootScope', '$i18n', function ($rootScope, $i18n) {
    return function BreadCrumbs () {

      this.crumbs = [];

      this.addCrumb = function() {

        var args = Array.prototype.slice.call(arguments);

        var crumb = {};

        if (_.isPlainObject(args[0])) {
          crumb = args[0];
        } else {
          crumb.text = args[0];
          crumb.sref = args[1];
          if (args[2]) {
            crumb.active = args[2];
          }
        }

        this.crumbs.push(crumb);

        return this;

      },

          this.clearCrumbs = function() {
            this.crumbs = [];
          },

          this.addCrumb($i18n.__('home'), 'dashboard');

      this.registerCrumbs = function(){
        $rootScope.breadcrumbs = this.crumbs;
      }

      this.registerCrumbs();

    };
  }]);

  app.service('$metadata', ['$rootScope', function($rootScope){
    $rootScope.metadata = {title:null, siteTitle:null, fb:null};
    $rootScope.ngMeta = {title: '', fb:{app_id: '', url:'', image:[], description:''}};
    this.setTitle = function (title) {
      $rootScope.metadata.title = title;
    }
    this.setSiteTitle = function (title) {
      $rootScope.metadata.siteTitle = title;
    }

    this.setObjFb = function(obj){
        $rootScope.ngMeta.fb = obj;
    }
    this.setSubTitle = function(subTitle){
      if($rootScope.metadata.siteTitle !== null){
        $rootScope.ngMeta.title = $rootScope.metadata.siteTitle + subTitle;
      }else{
        $rootScope.$watch('metadata.siteTitle', function(r){
          if(r !== null){
            $rootScope.ngMeta.title = $rootScope.metadata.siteTitle + subTitle;
          }
        });
      }
    }



    this.setSiteKeyWords = function (keywords) {
      $rootScope.metadata.keywords = keywords;
    }
    this.setSiteDescription = function (description) {
      $rootScope.metadata.description = description;
    }
  }]);

  app.service('$selectUIService', ['$rootScope', '$document', function($rootScope, $document){
    var blockBackSpace = function(e){
      return true;
    };
    this.handleAjax = function (options) {
      return function ($select) {
        var search = $select.search;
        if (search && search.length > options.searchMin) {
          $document.on('keydown', blockBackSpace);
          options.requestHandler({urlRouter: options.urlKey, param: search}).then(function(result){
            $document.off('keydown', blockBackSpace);
            options.responseHandler(result, $select);
          });
        } else {
          return null;
        }
      };
    };
  }]);


})();
define("default-service", function(){});

